/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/student.scss';
import PopAttendanceCheck from './_PopAttendanceCheck';
function MonthlyAttendance() {
  const [modalAttendanceCheck, setModalAttendanceCheck] = useState(false);
  return (
    <>
      <PopAttendanceCheck open={modalAttendanceCheck} close={() => setModalAttendanceCheck(false)} />
      <section className="com_month_calendar">
        <ul className="month_header">
          <li className="date">월</li>
          <li className="date">화</li>
          <li className="date">수</li>
          <li className="date">목</li>
          <li className="date">금</li>
          <li className="date saturday">토</li>
          <li className="date holiday">일</li>
        </ul>
        <div className="month_schedule">
          <ul className="month_body">
            <li className="date">
              <span className="day_index">1</span>
            </li>
            <li className="date red">
              <span className="day_index">2</span>
              <div className="info">
                <span className="tit com_red_txt">10회 결석</span>
                <span className="desc">19 : 00</span>
                <span className="desc">온라인 문제로 늦게 출석 체크했습니다.</span>
              </div>
            </li>
            <li className="date">
              <span className="day_index">3</span>
            </li>
            <li className="date red">
              <span className="day_index">4</span>
              <div className="info">
                <span className="tit com_red_txt">11회 연기</span>
                <span className="desc">19 : 00</span>
                <span className="desc">학생 사정으로 연기합니다.</span>
                <span className="desc com_red_txt">2023, 03, 17로 이동</span>
              </div>
            </li>
            <li className="date">
              <span className="day_index">5</span>
            </li>
            <li className="date">
              <span className="day_index">6</span>
            </li>
            <li className="date holiday">
              <span className="day_index">7</span>
            </li>
          </ul>
          <ul className="month_body">
            <li className="date">
              <span className="day_index">8</span>
            </li>
            <li className="date blue">
              <span className="day_index">9</span>
              <div className="info">
                <span className="tit com_red_txt">12회 수업일</span>
                <span className="tit com_red_txt line">출석 미체크</span>
                <span className="desc com_red_txt">19 : 00</span>
              </div>
            </li>
            <li className="date blue">
              <span className="day_index">10</span>
              <div className="info">
                <span className="tit com_blue_txt">12회 수업일</span>
                <button onClick={() => setModalAttendanceCheck(true)} className="tit com_blue_txt line">
                  출석체크
                </button>
                <span className="desc com_blue_txt">19 : 00</span>
              </div>
            </li>
            <li className="date">
              <span className="day_index">11</span>
            </li>
            <li className="date">
              <span className="day_index">12</span>
            </li>
            <li className="date">
              <span className="day_index">13</span>
            </li>
            <li className="date holiday">
              <span className="day_index">14</span>
            </li>
          </ul>
          <ul className="month_body">
            <li className="date">
              <span className="day_index">15</span>
            </li>
            <li className="date gray">
              <span className="day_index">16</span>
              <div className="info">
                <span className="tit disabled">13회 수업연기</span>
                <span className="desc disabled">(2023, 03, 04 수업이동)</span>
              </div>
            </li>
            <li className="date">
              <span className="day_index">17</span>
            </li>
            <li className="date">
              <span className="day_index">18</span>
            </li>
            <li className="date">
              <span className="day_index">19</span>
            </li>
            <li className="date">
              <span className="day_index">20</span>
            </li>
            <li className="date holiday">
              <span className="day_index">21</span>
            </li>
          </ul>
          <ul className="month_body">
            <li className="date">
              <span className="day_index">22</span>
            </li>
            <li className="date">
              <span className="day_index">23</span>
            </li>
            <li className="date">
              <span className="day_index">24</span>
            </li>
            <li className="date">
              <span className="day_index">25</span>
            </li>
            <li className="date">
              <span className="day_index">26</span>
            </li>
            <li className="date">
              <span className="day_index">27</span>
            </li>
            <li className="date holiday">
              <span className="day_index">28</span>
            </li>
          </ul>
          <ul className="month_body">
            <li className="date">
              <span className="day_index">29</span>
            </li>
            <li className="date">
              <span className="day_index">30</span>
            </li>
            <li className="date">
              <span className="day_index">31</span>
            </li>
            <li className="date disable">
              <span className="day_index">1</span>
            </li>
            <li className="date disable">
              <span className="day_index">2</span>
            </li>
            <li className="date disable">
              <span className="day_index">3</span>
            </li>
            <li className="date disable">
              <span className="day_index">4</span>
            </li>
          </ul>
        </div>
      </section>
    </>
  );
}

export default MonthlyAttendance;
